function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useMemo, useEffect, useRef, useCallback, Fragment } from 'react';
import { remove } from 'lodash';
import { Modal, Icon } from 'mkui-fd';
import Pin from '../Pin';
import { getMoreOptionsInitChoosedData } from './util';
var prefixCls = 'mkui-table-filter-more-options-modal';
export default function MoreOptionsModal(props) {
  var visible = props.visible,
      onDismiss = props.onDismiss,
      onClose = props.onClose,
      category = props.category,
      choosed = props.choosed;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      currentChoosed = _useState2[0],
      setCurrentChoosed = _useState2[1];

  useEffect(function () {
    setCurrentChoosed(choosed);
  }, [choosed]);
  /** *******************handle************************** */

  var selectHandle = function selectHandle(category, option) {
    // check is exsit
    var choosedFind = currentChoosed.find(function (code) {
      return code === option.code;
    });

    if (choosedFind) {
      remove(currentChoosed, function (code) {
        return code === option.code;
      });
      setCurrentChoosed(_toConsumableArray(currentChoosed));
      return;
    }

    if (category.excluded) {
      setCurrentChoosed([option.code]);
    } else {
      currentChoosed.push(option.code);
      setCurrentChoosed(_toConsumableArray(currentChoosed));
    }
  };

  var dismissHandle = function dismissHandle() {
    onDismiss();
  };

  var closeHandle = function closeHandle() {
    onClose(category, currentChoosed.map(function (code) {
      return category.options.find(function (o) {
        return o.code === code;
      });
    }));
  };

  var renderOptions = function renderOptions() {
    return category.options.map(function (item) {
      return React.createElement(Pin, {
        key: item.code,
        active: currentChoosed.indexOf(item.code) !== -1,
        onClick: function onClick() {
          return selectHandle(category, item);
        }
      }, item.label);
    });
  };

  return React.createElement(Modal, {
    title: "\u66F4\u591A\u9009\u9879",
    visible: visible,
    onCancel: dismissHandle,
    onOk: closeHandle,
    width: 600,
    wrapClassName: "".concat(prefixCls)
  }, React.createElement("div", {
    className: "".concat(prefixCls, "-content")
  }, renderOptions()));
}
//# sourceMappingURL=MoreOptionsModal.js.map
